﻿import $ from 'jquery';

$(function () {
  $(document).on('click', '[data-remove]', function () {
    let removeWhat: string = $(this).data('remove');
    let id = $(this).data('remove-id');

    let selector = removeWhat.asDataSelector(id);
    let $element = $(selector);

    if ($element.length <= 0)
      return true;

    $element.trigger('remove.rustig.removeelement');
    $(selector).remove();
    $element.trigger('removed.rustig.removeelement');
  });
});  